import { Button } from '@chakra-ui/react'
import { useThemeColors } from '@/hooks/useThemeColors'

type Props = {
  onAcknowledge: () => void
  isLoading?: boolean
}

export function QuickAcknowledgeButton({ onAcknowledge, isLoading }: Props) {
  const colors = useThemeColors()

  return (
    <Button
      size="sm"
      minW="160px"
      h="46px"
      px={6}
      fontWeight="600"
      borderRadius="md"
      bg={colors.brandBlue}
      color="white"
      boxShadow="0 2px 4px rgba(0,0,0,0.15)"
      _hover={{
        bg: colors.brandBlueHover,
        boxShadow: '0 4px 8px rgba(0,0,0,0.18)',
        transform: 'translateY(-1px)',
      }}
      _active={{
        bg: colors.brandBlueActive,
        transform: 'translateY(0)',
      }}
      _disabled={{
        opacity: 0.6,
        cursor: 'not-allowed',
      }}
      onClick={onAcknowledge}
      isLoading={isLoading}
    >
      Acknowledge
    </Button>
  )
}